import React, { useEffect, useRef } from "react";

export const useCustomRefHook = <T extends any>(dependencies: any[] | null): React.MutableRefObject<T | null> => {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    // Ваш код внутри useEffect
  }, Array.isArray(dependencies) ? dependencies : []); // Убедитесь, что dependencies - это массив

  return ref;
};
